export enum AccountActionTypes {
  login = "login",
  logout = "logout",
  signup = "signup",
}
